(() => {
  const initializeGallery = (gallery) => {
    if (gallery.dataset.klicGalleryInitialized === 'true') return;

    const thumbs = [...gallery.querySelectorAll('[data-klic-gallery-thumb]')];
    const frames = [...gallery.querySelectorAll('[data-klic-gallery-frame]')];
    if (!thumbs.length || thumbs.length !== frames.length) return;

    const show = (index) => {
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', String(active));
      });
      frames.forEach((frame, frameIndex) => frame.classList.toggle('is-active', frameIndex === index));
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => show(index));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) return;
        event.preventDefault();
        const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
        const nextIndex = (index + direction + thumbs.length) % thumbs.length;
        thumbs[nextIndex].focus();
        show(nextIndex);
      });
    });

    gallery.dataset.klicGalleryInitialized = 'true';
  };

  const initializeAll = () => document.querySelectorAll('[data-klic-kit-gallery]').forEach(initializeGallery);
  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.('[data-klic-kit-gallery]')) initializeGallery(event.target);
    event.target.querySelectorAll?.('[data-klic-kit-gallery]').forEach(initializeGallery);
  });
})();
